import { RouteObject } from "react-router-dom";
import { KnowledgeBase } from "../pages/admin/knowledge-base/KnowledgeBase";

export const knowledgeBaseRoutes: RouteObject[] = [
  {
    id: "knowledge-base",
    index: true,
    element: <KnowledgeBase />,
  },
];
